import ICommand from '../../FrontApplet/Command/ICommand';
import { ITypedCommandEvent } from '../../FrontApplet/Command/ICommandEvent';
import FrontApplet from '../../FrontApplet/FrontApplet';
import IVideoEvent from '../../FrontApplet/Video/IVideoEvent';
import { VideoStateChanged } from './videoCommands';

export function handleVideoRequests(
	_onCommand: (callback: (commandEvent: ITypedCommandEvent<any>) => Promise<void>) => void,
	dispatch: <TCommand extends ICommand>(command: TCommand) => void,
	frontApplet: FrontApplet,
) {
	frontApplet.video.onPlay((event: IVideoEvent) => {
		dispatch<VideoStateChanged>({
			type: VideoStateChanged,
			state: 'play',
			...event.srcArguments,
		});
	});

	frontApplet.video.onPrepare((event: IVideoEvent) => {
		dispatch<VideoStateChanged>({
			type: VideoStateChanged,
			state: 'prepare',
			...event.srcArguments,
		});
	});

	frontApplet.video.onStop((event: IVideoEvent) => {
		dispatch<VideoStateChanged>({
			type: VideoStateChanged,
			state: 'stop',
			...event.srcArguments,
		});
	});

	frontApplet.video.onPause((event: IVideoEvent) => {
		dispatch<VideoStateChanged>({
			type: VideoStateChanged,
			state: 'pause',
			...event.srcArguments,
		});
	});

	frontApplet.video.onResume((event: IVideoEvent) => {
		dispatch<VideoStateChanged>({
			type: VideoStateChanged,
			state: 'resume',
			...event.srcArguments,
		});
	});

	frontApplet.video.onEnded((event: IVideoEvent) => {
		dispatch<VideoStateChanged>({
			type: VideoStateChanged,
			state: 'ended',
			...event.srcArguments,
		});
	});

	frontApplet.video.onError((event: IVideoEvent) => {
		dispatch<VideoStateChanged>({
			type: VideoStateChanged,
			state: 'error',
			...event.srcArguments,
		});
	});
}
